export default __webpack_public_path__ + "static/media/dashboard.34c7d9ab.svg";